const ccpurl = 'https://pragyaa.awsapps.com/connect/ccp-v2#';

export default ccpurl;
